import { languages } from "@/app/constants";
import React from "react";
import Language from "./Language";

function Languages({ languages }: LanguagesTypeProps) {
  return (
    <>
      {languages.map((language) => (
        <Language {...language} key={language.key} />
      ))}
    </>
  );
}

export default Languages;
type LanguagesTypeProps = {
  languages: typeof languages;
};
